import React from "react";
import { useTheme } from "next-themes";
import { Moon, Sun, Monitor } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "./ui/dropdown-menu";

export default function ThemeToggle({ testid = "theme-toggle" }) {
  const { theme, setTheme, resolvedTheme } = useTheme();
  const [mounted, setMounted] = React.useState(false);

  React.useEffect(() => setMounted(true), []);

  if (!mounted) {
    return (
      <button
        type="button"
        aria-label="Tema"
        data-testid={testid}
        className="p-2 rounded-sm text-muted-foreground"
      >
        <Sun className="h-4 w-4" strokeWidth={1.75} />
      </button>
    );
  }

  const Icon = resolvedTheme === "dark" ? Moon : Sun;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          type="button"
          data-testid={testid}
          aria-label="Cambiar tema"
          title="Tema claro / oscuro"
          className="p-2 rounded-sm text-muted-foreground hover:bg-muted hover:text-foreground transition-colors"
        >
          <Icon className="h-4 w-4" strokeWidth={1.75} />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-40">
        <DropdownMenuItem
          data-testid="theme-light"
          onClick={() => setTheme("light")}
          className={theme === "light" ? "font-medium" : ""}
        >
          <Sun className="h-4 w-4 mr-2" strokeWidth={1.75} />
          Claro
        </DropdownMenuItem>
        <DropdownMenuItem
          data-testid="theme-dark"
          onClick={() => setTheme("dark")}
          className={theme === "dark" ? "font-medium" : ""}
        >
          <Moon className="h-4 w-4 mr-2" strokeWidth={1.75} />
          Oscuro
        </DropdownMenuItem>
        <DropdownMenuItem
          data-testid="theme-system"
          onClick={() => setTheme("system")}
          className={theme === "system" ? "font-medium" : ""}
        >
          <Monitor className="h-4 w-4 mr-2" strokeWidth={1.75} />
          Sistema
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
